export default __webpack_public_path__ + "static/media/gtd4.23d8f36d.jpg";